import { render } from "./Biography.vue?vue&type=template&id=5ac63e4f"
import script from "./Biography.vue?vue&type=script&lang=js"
export * from "./Biography.vue?vue&type=script&lang=js"

import "./Biography.vue?vue&type=style&index=0&id=5ac63e4f&lang=css"
script.render = render

export default script